import { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/Logo 10 Designs (1).png';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
  const location = useLocation();
  let dropdownTimeout = null;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleProjectsMouseEnter = () => {
    if (dropdownTimeout) clearTimeout(dropdownTimeout);
    setShowProjectsDropdown(true);
  };

  const handleProjectsMouseLeave = () => {
    dropdownTimeout = setTimeout(() => {
      setShowProjectsDropdown(false);
    }, 200); // 200ms delay
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
         <Link
  to="/"
  className="logo"
  onClick={(e) => {
    setIsMenuOpen(false);
    if (location.pathname === '/') {
      e.preventDefault(); // Don't re-navigate if already on homepage
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }}
>

            <div className="logo-img-container">
              <img src={logo} alt="10 Designs" className='logo-img'/>
            </div>
            <div className="logo-text">
              <h2>10 Designs </h2>
              <p>Designing Space. Defining Style. Delivering Vision.</p>
            </div>
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                <Link to="/about" className={location.pathname === '/about' ? 'ser' : ''} onClick={() => setIsMenuOpen(false)}>
                  About
                </Link>
              </li>
              <li
                className="projects-dropdown"
                onMouseEnter={handleProjectsMouseEnter}
                onMouseLeave={handleProjectsMouseLeave}
              >
                <Link to="/projects" className={location.pathname.startsWith('/projects') ? 'ser' : ''} onClick={() => setIsMenuOpen(false)}>
                  Projects
                </Link>
                {showProjectsDropdown && (
                  <ul className="dropdown-menu" onMouseEnter={handleProjectsMouseEnter} onMouseLeave={handleProjectsMouseLeave}>
                    <li><Link to="/projects/residential" onClick={() => setIsMenuOpen(false)}>Residential</Link></li>
                    <li><Link to="/projects/industrial" onClick={() => setIsMenuOpen(false)}>Industrial</Link></li>
                    <li><Link to="/projects/commercial" onClick={() => setIsMenuOpen(false)}>Commercial</Link></li>
                  </ul>
                )}
              </li>
              <li>
                <Link to="/services" className={location.pathname === '/services' ? 'ser' : ''} onClick={() => setIsMenuOpen(false)}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className={location.pathname === '/contact' ? 'ser' : ''} onClick={() => setIsMenuOpen(false)}>
                  Contact
                </Link>
              </li>
              
            </ul>
          </nav>

          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 